import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

interface Props {
    show?: boolean;
    width?: number;
    noTitle?: boolean;
}

export const LayerPopUpContainer = styled.div<Props>`
    ${props => props.show ? css`display: block;` : css`display: none;`}
    position: fixed;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    ${props => {
        return css`
            ${LayerPopUpWrapper} {
                ${props.width ? css`
                    max-width: ${props.width}px;
                    max-height: 90vh;
                    width:80vw; 
                    overflow-y: auto;` : css``
            }
            }
        `;
    }}
`;

export const LayerDim = styled.div`
    z-index: 2;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: ${palette('gray_opacity_800')};
`;

export const LayerPopUpWrapper = styled.div`
    z-index: 2;
    position: absolute;
    width: 100%;
    border-radius: 8px;
    background-color: ${palette('gray_opacity_50')};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const CloseWrapper = styled.div`
    position: relative;
    height: 56px;
    width: 100%;

    > button {
        position: absolute;
        display: block;
        right: 20px;
        width: 24px;
        top: 12px;
        padding: 5px;
    }
`;

export const TitleWrapper = styled.div`
    height: 59px;
    display: flex;
    align-items: center;
`;

export const ChildrenWrapper = styled.div<Props>`
    ${props => props.noTitle ? css`margin-top:24px;` : css``}
    > * {
        border-radius: 8px;

        &:not(:last-child) {
            margin-bottom: 12px;
        }
    }
`;

export const BtnWarpper = styled.div`
    margin-top: 12px;
    padding: 12px 0;
    display: flex;
    > button {
        :not(:last-child) {
            margin-right: 2px;
        }
        border-radius: 8px;
    }
`;

export const PopupBodyContiner = styled.div`
    padding: 0 20px 12px 20px;
`;